import { createReducer } from 'typesafe-actions';

import * as actions from 'store/host-info/actions';
import { HostInfoState } from 'store/host-info/types';

export const getInitialState = (): HostInfoState => ({ platform: null, isNativeApp: false, isSettled: false });

export const initialState: HostInfoState = getInitialState();

const setHostInfoHandler = (
  state: HostInfoState,
  { payload }: ReturnType<typeof actions.setHostInfo>,
): HostInfoState => ({
  ...state,
  platform: payload.platform,
  isNativeApp: payload.isNativeApp,
  isSettled: true,
});

const hostInfoReducer = createReducer(initialState).handleAction(actions.setHostInfo, setHostInfoHandler);

export default hostInfoReducer;
